import { QueryClient } from '@tanstack/react-query';

/**
 * Tek QueryClient. Varsayilanlar doviz verisinin dogasina gore secildi:
 * kurlar hizli bayatlar, ama her odak degisiminde yeniden istek atmak
 * gateway'i gereksiz yorar.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});
